import * as Sentry from "@sentry/node";
import Router from "next/router";
import NProgress from "nprogress";
import Head from "next/head";
import { RecoilRoot } from "recoil";

import "../styles/globals.scss";
import "../styles/nprogress.css";

import config from "../src/config";
import { isProduction } from "../src/common/utils/environment";

if (config.sentry.dsn) {
  Sentry.init({
    enabled: isProduction(),
    dsn: config.sentry.dsn,
  });
}

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

function MyApp({ Component, pageProps, err }) {
  return (
    <RecoilRoot>
      <div>
        <Head>
          <title>HarTy!</title>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
        </Head>
        <Component {...pageProps} err={err} />
      </div>
    </RecoilRoot>
  );
}

export default MyApp;
